/**
 * Extrait le tableau `categories` des réponses GET `/api/institution/categories`, quelle que soit
 * la forme d’enveloppe (`success` + `data`, ou données déjà à plat).
 */
import { isLyrraOne } from '@/lib/platform';

/** Liste des catégories formation : Studio institution vs parcours formateur LyrraOne. */
export function institutionCategoriesApiPath(): string {
  return isLyrraOne() ? '/auth/me/institution-categories' : '/institution/categories';
}

/** Base CRUD catégories (LyrraOne réutilise l’alias `/institution/categories`). */
export function institutionCategoriesCrudPath(): string {
  return '/institution/categories';
}

export function extractInstitutionCategoriesFromApiResponse(raw: unknown): unknown[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;

  if (typeof raw !== 'object') return [];

  const root = raw as Record<string, unknown>;

  const inner = root.data;
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    const d = inner as Record<string, unknown>;
    if (Array.isArray(d.categories)) return d.categories;
  }

  if (Array.isArray(root.categories)) return root.categories;

  if (Array.isArray(root.data) && root.data.every((x) => x && typeof x === 'object')) {
    return root.data as unknown[];
  }

  return [];
}
